export const SET_RECEIVER_ID = "SET_RECEIVER_ID";
export const UNSET_RECEIVER_ID = "UNSET_RECEIVER_ID";
export const SET_TYPING_VALUE = "SET_TYPING_VALUE";

export const SEND_MESSAGE_START = "SEND_MESSAGE_START";
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS";
export const SEND_MESSAGE_FAIL = "SEND_MESSAGE_FAIL";

export const DELETE_MESSAGE = "DELETE_MESSAGE";
export const EDIT_MESSAGE = "EDIT_MESSAGE";
export const EDITED_MESSAGE = "EDITED_MESSAGE";
export const DETAILS_INFO = "DETAILS_INFO";


export const POST_USER_STATUS_START = "POST_USER_STATUS_START";
export const POST_USER_STATUS_SUCCESS = "POST_USER_STATUS_SUCCESS";
export const POST_USER_STATUS_FAIL = "POST_USER_STATUS_FAIL";

export const POST_PROFILE_PICTURE_START = "POST_PROFILE_PICTURE_START";
export const POST_PROFILE_PICTURE_SUCCESS = "POST_PROFILE_PICTURE_SUCCESS";
export const POST_PROFILE_PICTURE_FAIL = "POST_PROFILE_PICTURE_FAIL";

//auth actionTypes
export const REQUEST_SIGNUP_START = "REQUEST_SIGNUP_START";
export const REQUEST_SIGNUP_SUCCESS = "REQUEST_SIGNUP_SUCCESS";
export const REQUEST_SIGNUP_FAIL = "REQUEST_SIGNUP_FAIL";

export const REQUEST_USERLOGIN_START = "REQUEST_USERLOGIN_START";
export const REQUEST_USERLOGIN_SUCCESS = "REQUEST_USERLOGIN_SUCCESS";
export const REQUEST_USERLOGIN_FAIL = "REQUEST_USERLOGIN_FAIL";

export const SIGNOUT_START = "SIGNOUT"
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS"
export const SIGNOUT_FAIL = "SIGNOUT_FAIL"